/**
 * @file 雇用形態の変更を監視
 */
'use strict'

/**
 * @classname ChangeEmploymentStatus
 * @classdesc 雇用形態の変更を監視
 */
export default class ChangeEmploymentStatus {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-toggle-password')
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`)
		this._$e = $e
		this._$welfareInsurance = $('.input-text-welfare-insurance')
		this._$e.on('change', () => this.onChange())
	}

	/**
	 * onChangeのコールバック
	 *
	 * @memberof ChangeEmploymentStatus
	 * @description 雇用形態が派遣,紹介予定派遣の場合は「雇用保険・労災・健康保険・厚生年金　※加入条件あり」と自動表記で編集不可、正社員かアルバイトの場合は「雇用保険・労災・健康保険・厚生年金　※加入条件あり」で表記し編集可能に
	 * @return {undefined}
	 */
	onChange() {
		console.log(`${this.constructor.name}.onChange`)
		const terms = '雇用保険・労災・健康保険・厚生年金 ※加入条件あり'
		const className = this._$e.find('option:selected').attr('class')
		if (className === 'introduce-temporary-staff' || className === 'temporary-staff') {
			console.log('派遣,紹介予定派遣 が選択')
			this._$welfareInsurance.val(terms)
			this._$welfareInsurance.prop('readonly', true)
		} else {
			this._$welfareInsurance.prop('readonly', false)
			if (className === 'full-time-employee' || className === 'part-timer') {
				console.log('正社員かアルバイト が選択')
				this._$welfareInsurance.val(terms)
			} else {
				this._$welfareInsurance.val('')
			}
		}
	}
}
